/* eslint-disable no-param-reassign */
/**
 * This method accepts the useGetAlertsQuery data response and filters
 * the results to return only the most recent alert. It accomplishes
 * this by returning the one with the highest 'begin' property.
 * @param {Object} data - useGetAlertsQuery response
 * @returns {Array}
 */
const returnMostRecentAlert = (data = {}) => {
  return data.systemWideAlerts?.length > 0
    ? Array(
        data?.systemWideAlerts.reduce((max, current) => {
          if (current.begin > max.begin) {
            max = current;
          }
          return max;
        })
      )
    : [];
};

export default returnMostRecentAlert;
